module.exports = __webpack_public_path__ + "static/media/flagGreen.bba00c8e.svg";